import * as React from 'react';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';

interface SortableItemProps {
    value: string;
    id: number;
}

const SortableItem = SortableElement<SortableItemProps>(({value, id}) =>
    <div className='dad__style__item dad__style__stylizedItem'>
        <p className='chat__contact-name'>{id + 1} - {value}</p>
    </div>
);

interface SortableListProps {
    items: string[];
    className: string;
}

export const SortableList = SortableContainer<SortableListProps>(({items, className}) => {
    return (
        <div className={`dad__style__list dad__style__stylizedList ${className}`}>
            {items.map((value, index) =>
                <SortableItem key={`item-${index}`} index={index} value={value} id={index}/>
            )}
        </div>
    );
});



// WEBPACK FOOTER //
// ./src/components/common/sortable-hoc/sortable-list.tsx